import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { StorageService } from './storage.service';
import { KeycloakAuthService } from './keycloak-auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const keycloakAuth = inject(KeycloakAuthService);
  const router = inject(Router);
  const storageService = inject(StorageService);

  if (keycloakAuth.isLoggedIn()) {
    return of(true);
  }

  storageService.saveRedirectUrl(state.url);
  router.navigateByUrl('/account/login').catch((err) => {
    console.error('Navigation to login failed:', err);
    storageService.forceRedirectToLogin();
  });
  return of(false);
};
